<template>
  <div class="frontresetpwd">
    <div class="resetpwd-content">
      <div class="resetpwd_title">重置密码</div>
      <div class="resetpwd_form_wrapper">
        <el-form :model="resetpwdForm" status-icon ref="resetpwdForm" :rules="rules" label-width="10px" class="resetpwdform">
          <el-form-item label="" prop="mobile">
            <el-input v-model.trim="resetpwdForm.mobile" autocomplete="off" placeholder="手机号" max="20" clearable>
              <i slot="prefix" class="el-input__icon icon-my-user"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="imageCode" class="image-code-item">
            <el-input v-model.trim="resetpwdForm.imageCode" autocomplete="off" placeholder="图形验证码" :maxlength="10" clearable class="validcode">
              <i slot="prefix" class="el-input__icon icon-my-validcode"></i>
            </el-input>
            <img class="image-code-img" :src="imageCodeSrc" @click="refreshImageCode">
          </el-form-item>
          <el-form-item label="" class="pstv">
            <el-input v-model.trim="resetpwdForm.smsCode" autocomplete="off" placeholder="验证码" :maxlength="8" class="validcode">
              <i slot="prefix" class="el-input__icon icon-my-validcode"></i>
            </el-input>
            <el-button class="sendcode" @click="sendCode" :disabled="!show" type="text">{{ showCount }}</el-button>
          </el-form-item>
          <el-form-item label="" prop="password">
            <el-input type="password" v-model.trim="resetpwdForm.newPassword" autocomplete="off" placeholder="新密码" max="100" clearable>
              <i slot="prefix" class="el-input__icon icon-my-password"></i>
            </el-input>
          </el-form-item>
          <el-form-item label="" prop="confirmPassword">
            <el-input type="password" v-model.trim="resetpwdForm.confirmPassword" autocomplete="off" placeholder="确认密码" max="100" clearable>
              <i slot="prefix" class="el-input__icon icon-my-password"></i>
            </el-input>
          </el-form-item>
        </el-form>
        <el-button class="resetpwd_btn" @click="submitForm('resetpwdForm')" @keyup.enter.native="submitForm('resetpwdForm')">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import smsImageCodeMixin from '@/mixins/smsImageCodeMixin'
import commonService from '@/service/commonService'

export default {
  mixins: [smsImageCodeMixin],
  components: {},
  data: function () {
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      }
      if (value && (value.replace(/^\s+|\s+$/gm, '').length < 6 || value.replace(/^\s+|\s+$/gm, '').length > 18)) {
        callback(new Error('密码长度为6-18位'))
      }
      if (value !== this.resetpwdForm.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      resetpwdForm: {
        mobile: '',
        imageCode: '',
        smsCode: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        mobile: [
          { required: true, message: '请输入登录手机号码', trigger: 'blur' },
          { validator: this.$rules.phoneNumber, trigger: 'blur' }
        ],
        imageCode: [
          { required: true, message: '请输入图形验证码', trigger: 'blur' }
        ],
        newPassword: [{ required: true, message: '请输入正确密码', trigger: 'blur' }],
        confirmPassword: [
          { required: true, message: '请输入正确密码', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  name: 'frontresetpwd',
  methods: {
    async sendCode () {
      await this.sendSmsCodeWithImage()
    },
    submitForm (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.$cookie.set('token', this.SysConstant.basicAuth)
          this.$cookie.set('deviceId', this.resetpwdForm.mobile)
          try {
            await commonService.resetFrontPassword(this.resetpwdForm)
            this.$alert('密码重置成功,是否返回到登录页', '', {type: 'success'}).then(() => {
              this.$router.push({name: 'frontlogin'})
            })
          } catch (e) {
            this.$message.error(e && e.msg)
          }
        } else {
          this.$message.error('登录失败')
          return false
        }
      })
    },
    forgetPwd () {
      this.$router.push({name: 'frontpwd'})
    }
  }
}
</script>

<style scoped>
  .frontresetpwd{
    height: 100%;
    width: 100%;
    background-color: #F6F6F6;
  }
  .frontresetpwd .resetpwd_title{
    height:22px;
    margin: 50px 0px;
    font-size:22px;
    letter-spacing: 2px;
    text-align: center;
    font-family:MicrosoftYaHei;
    font-weight:600;
    color:rgba(51,51,51,1);
  }
  .frontresetpwd .resetpwd-content{
    width: 1200px;
    height: 70%;
    background-color: #ffffff;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    box-shadow:0px 5px 10px 0px rgba(0, 0, 0, 0.08);
  }
  .frontresetpwd .resetpwd-content .resetpwd_form_wrapper{
    width: 360px;
    margin: 0 auto;
    text-align: center;
  }
  .frontresetpwd * {
    color: #333333;
  }
  .frontresetpwd .resetpwd-content .resetpwd_form_wrapper .resetpwd_btn {
    color: #FFFEFE;
    background: rgba(16, 142, 233, 1);
    width: 350px;
    height: 40px;
    border-radius: 6px;
    margin-bottom: 22px;
    margin-left: 10px;
  }
  .frontresetpwd .resetpwd-content  .sendcode {
    color:#108EE9!important;
    font-size:14px;
    font-family:MicrosoftYaHei;
    font-weight:400;
    background: transparent;
    width: 110px;
    position: absolute;
    top: 0px;
    text-align: right;
    right: 20px;
  }
  .frontresetpwd .resetpwd-content .sendcode.is-disabled{
    color:#999999!important;
  }
  .frontresetpwd .resetpwd-content .image-code-item{
    position: relative;
  }
  .frontresetpwd .resetpwd-content .image-code-img{
    width: 120px;
    height: 34px;
    position: absolute;
    top: 3px;
    right: 20px;
    border-radius: 4px;
    cursor: pointer;
  }
</style>

<style type="text/css">
  .frontresetpwd .resetpwd-content  .el-form-item.is-success .el-input__inner,
  .frontresetpwd .resetpwd-content  .el-form-item.is-success .el-textarea__inner{
    border-color:#D6D6D6;
  }
  .frontresetpwd .resetpwd-content  .el-form-item .el-input__inner:focus,
  .frontresetpwd .resetpwd-content  .el-form-item .el-textarea__inner:focus{
    background:rgba(255,255,255,1);
    border:1px solid rgba(16,142,233,1);
    box-shadow:0px 0px 10px 0px rgba(16,142,233,0.3);
    border-radius:6px;
  }
  .frontresetpwd  .el-form-item__error{
    color: #f56c6c;
    font-size: 12px;
    padding-top: 0px;
    position: absolute;
    line-height: 40px;
    height: 40px;
    top:0;
    left: 360px;
    width: 200px;
    text-align: left;
  }
  .frontresetpwd .el-input--prefix .el-input__inner{
    padding-left: 35px;
  }
  .frontresetpwd .validcode span.el-input__prefix{
    line-height:40px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/front/front-password/index.vue